/*
 * Copyright (c) 2012 Mathieu Turcotte
 * Licensed under the MIT license.
 */

module.exports = require('./lib/checks');


//////////////////
// WEBPACK FOOTER
// ./~/precond/index.js
// module id = 76
// module chunks = 0